<template>
  <div class="message">
    <md-tab-bar
      v-model="current"
      :items="items"
      @change="onTabChange"
      style="z-index: 999;position: fixed;top: 0;width: 100%"
    ></md-tab-bar>
    <div style="width: 100%;height: 1rem"></div>
    <v-refresh :on-refresh="onRefresh">
      <v-reload
        :on-infinite-load="onInfiniteLoad"
        :parent-pull-up-state="infiniteLoadData.pullUpState"
      >
        <md-swiper
          ref="swiper"
          :autoplay="0"
          :is-prevent="false"
          :is-loop="false"
          :has-dots="false"
          @before-change="onSwiperChange"
        >
          <md-swiper-item>
            <md-field v-if="newone.length > 0">
              <md-cell-item
                v-for="(item, index) in newone"
                :key="index"
                :title="item.title"
                @click="osmr(item.type,item.id)"
                :brief="item.messageContext"
                :addon="item.createTime | dateformat('YYYY-MM-DD HH:mm:ss')"
              />
            </md-field>
            <noth-modal v-else></noth-modal>
            <div style="width: 100%;height: 2rem"></div>
          </md-swiper-item>
          <md-swiper-item>
            <md-field v-if="newtwo.length > 0">
              <md-cell-item
                v-for="(item, index) in newtwo"
                :key="index"
                :title="item.title"
                :addon="item.createTime | dateformat('YYYY-MM-DD HH:mm:ss')"
                @click="openCountryModal(item)"
              />
            </md-field>
            <noth-modal v-else></noth-modal>
            <div style="width: 100%;height: 2rem"></div>
          </md-swiper-item>
        </md-swiper>
      </v-reload>
    </v-refresh>

    <!-- 弹出公告 -->
    <md-landscape
      v-model="showCustomTransition"
      transition="md-bounce"
      :mask-closable="true"
    >
      <div class="eJectModal">
        <div class="title">
          {{ EjectData.title }}
        </div>
        <div class="content" v-html="EjectData.content"></div>
      </div>
    </md-landscape>
  </div>
</template>

<script>
import { TabBar, Swiper, SwiperItem, Field, CellItem, Landscape } from "mand-mobile";
import DropDownRefresh from "../../components/refresh";
import PullUpReload from "../../components/pullDown";
import NothModal from "../Modal/NothModal";
export default {
  name: "message",
  components: {
    [TabBar.name]: TabBar,
    [Swiper.name]: Swiper,
    [Field.name]: Field,
    "v-refresh": DropDownRefresh,
    "v-reload": PullUpReload,
    [CellItem.name]: CellItem,
    [SwiperItem.name]: SwiperItem,
    [Landscape.name]: Landscape,
    NothModal
  },
  data() {
    return {
      infiniteLoadData: {
        initialShowNum: 10, // 初始显示多少条
        everyLoadingNum: 10, // 每次加载的个数
        pullUpState: 4, // 子组件的pullUpState状态
        pullUpList: [], // 上拉加载更多数据的数组
        showPullUpListLength: this.initialShowNum // 上拉加载后所展示的个数
      },
      newone: [],
      newtwo: [],
      pagenum: 1,
      isFinished: false,
      current: 0,
      items: [
        { name: 0, label: "消息" },
        { name: 1, label: "公告" }
      ],
      // 公告信息
      EjectData: {},
      showCustomTransition: false
    };
  },
  activated() {
    // this.$el.querySelector('.load-more').style.display = 'none';
    this.showCustomTransition = false
    this.current = 0
    this.getMessageList("fresh");
  },
  mounted() {},
  methods: {
    onSwiperChange(from, to) {
      this.current = to;
      this.getMessageList()
    },
    getMessageList(tip) {
      if (this.current === 0) {
        const par = {
          pageNum: this.pagenum,
          pageSize: 10
        };
        this.http
          .APIASK(this.ports.getMessageList, "get", par)
          .then(res => {
            var newone = res.list.filter(item => item.type != 3);
            var newtwo = res.list.filter(item => item.type == 3);
            if (tip == "load") {
              if (res.list.length > 0) {
                this.infiniteLoadData.pullUpList = this.list;
                if (res.list.length < 5) {
                  this.infiniteLoadData.pullUpState = 3;
                } else {
                  this.infiniteLoadData.pullUpState = 1;
                }
              } else {
                this.infiniteLoadData.pullUpState = 3;
              }
              this.newone = this.newone.concat(newone);
              this.newtwo = this.newtwo.concat(newtwo);
            } else {
              if (res.list.length < 5) {
                this.infiniteLoadData.pullUpState = 3;
              } else {
                this.infiniteLoadData.pullUpState = 1;
              }
              res.list.length < 3
                ? (this.infiniteLoadData.pullUpState = 0)
                : null;
              this.newone = newone;
              this.newtwo = newtwo;
            }
          })
          .catch(err => {});
      } else if (this.current === 1) {
        const par = {
          pageNum: this.pagenum,
          pageSize: 10,
          countryId: this.$route.query.id,
          appcode: JSON.parse(localStorage.getItem("shopkey")).appCode
        };
        this.http
          .APIASK(this.ports.getCountryNotice, "get", par)
          .then(res => {
            var newtwo = res.list;
            if (tip == "load") {
              if (res.list.length > 0) {
                this.infiniteLoadData.pullUpList = this.list;
                if (res.list.length < 5) {
                  this.infiniteLoadData.pullUpState = 3;
                } else {
                  this.infiniteLoadData.pullUpState = 1;
                }
              } else {
                this.infiniteLoadData.pullUpState = 3;
              }
              this.newtwo = this.newtwo.concat(newtwo);
            } else {
              if (res.list.length < 5) {
                this.infiniteLoadData.pullUpState = 3;
              } else {
                this.infiniteLoadData.pullUpState = 1;
              }
              res.list.length < 3
                ? (this.infiniteLoadData.pullUpState = 0)
                : null;
              this.newtwo = newtwo;
            }
          })
          .catch(err => {});
      }
    },
    osmr(type,id){
      const  par={
        id:id
      }
      this.http.APIASK(this.ports.detailmessage, "get", par)
        .then(res => {
          if(type===5){
            this.$router.push({name:'Fankuilist'})
          }
        })

      console.log(type)
    },
    onTabChange(item, index) {
      this.$refs.swiper.goto(index);
    },
    onRefresh(done) {
      setTimeout(() => {
        this.pagenum = 1;
        this.getMessageList("fresh");
        done();
      }, 1000);
    },
    onInfiniteLoad(done) {
      if (this.infiniteLoadData.pullUpState === 1) {
        this.pagenum++;
        this.getMessageList("load");
        done();
      } else {
        done();
        this.infiniteLoadData.pullUpState = 0;
      }
    },
    openCountryModal(record) {
      this.EjectData = record;
      this.showCustomTransition = true;
    }
  }
};
</script>

<style lang="less">
.md-tab-bar-item.is-active {
  color: #e32c1a;
}
.md-tab-bar-ink {
  background-color: #e32c1a;
}
.message {
  .md-field {
    padding: 0 0.3rem;
  }
  .md-cell-item-title {
    text-align: left;
  }
  .md-cell-item-brief {
    text-align: left;
  }
  .md-cell-item-right {
    margin-top: -0.8rem;
  }
  .md-cell-item-body.multilines {
    padding: 0.2rem;
  }
  .md-cell-item-brief {
    line-height: 2;
  }
  .message .md-cell-item-body.multilines {
    padding: 0;
  }
}

.md-landscape .md-icon.md-landscape-close {
  display: block;
}
.md-landscape-content {
  width: 7.4rem;
}
</style>
